import {observer} from 'mobx-react-lite';
import React, {FunctionComponent} from 'react';

import {mainState} from './AppMainState';
import {Bottombar} from './components/Bottombar';
import {Sidebar} from './components/Sidebar';
import {ChooseOffer} from './views/payments/ChooseOffer';
import {MusculaTour} from './views/tour/MusculaTour';
import {PublicClientApplication} from '@azure/msal-browser';
import {GOOGLE_LOGIN_CLIENT_ID, msalConfig} from './components/social-login/SocialLoginState';
import {MsalProvider} from '@azure/msal-react';
import {AppRouting} from './routing/AppRouting';
import {browserHistory} from './routing/browserHistory';
import {HistoryRouter} from './routing/HistoryRouter';
import {GoogleOAuthProvider} from '@react-oauth/google';


const msalInstance = new PublicClientApplication(msalConfig);

export const App: FunctionComponent<any> = observer(() =>
    <GoogleOAuthProvider clientId={GOOGLE_LOGIN_CLIENT_ID}>
        <div className={mainState.currentUser ? 'bg-m-gray-2 flex flex-col xl:flex-row h-screen max-h-screen w-full' : ''}>
            {mainState.appInitialized && <HistoryRouter history={browserHistory}>
                {mainState.currentUser && <React.Fragment>
                    <Sidebar />
                    <main
                        className={'h-screen overflow-x-hidden overflow-y-scroll xs:px-6 xs:py-5 w-full lg:px-10 lg:py-8 transition-all duration-200' + (mainState.isShrinked ? 'shrinkedSidebarMargin' : '')}>
                        {!mainState.currentUser.accountExpired && <AppRouting />}
                        {mainState.currentUser.accountExpired && <ChooseOffer />}
                    </main>
                    <Bottombar />
                </React.Fragment>}
                {!mainState.currentUser && <MsalProvider instance={msalInstance}><AppRouting /></MsalProvider>}
            </HistoryRouter>}
            {mainState.isTourOpen && <MusculaTour />}
        </div>
    </GoogleOAuthProvider>,
);
